import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UsersCard from "./UsersCard";
import { getUsersList, deleteUserListDetails } from "../Actions/UserManageAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import "./UserManagementMaster.css";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

const PAGE_SIZE = 15;

let searchItem = {
  Mail: "",
  PageNumber: 1,
  PageSize: PAGE_SIZE,
};

class UserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Mail: "",
        PageNumber: 1,
        PageSize: PAGE_SIZE,
      },
    };
    this.SearchUserList = this.SearchUserList.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, userSearch, t } = this.props;
    if (userSearch) {
      this.state.searchData = userSearch;
    }
    dispatch(getUsersList(this.state.searchData));
    dispatch({
      type: "SubBannerTitle",
      data: t("MMPLUserManagementContent.Title").toUpperCase(),
    });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (searchitem.Mail != "") {
          _this.SearchUserList(1);
        } else {
          toast.success(t("Toast.Success"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    };

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {
    $(document).off("keypress", this.keyPressHandler);
  }

  SearchUserList(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "userSearch", data: this.state.searchData });
    dispatch(getUsersList(this.state.searchData));
  }

  SearchUserList1(pgno) {
    const { dispatch, t } = this.props;
    if (this.state.searchData.Mail !== "") {
      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "userSearch", data: this.state.searchData });
      dispatch(getUsersList(this.state.searchData));
    } else {
      toast.success(t("Toast.Success"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  ClearInput() {
    const { dispatch } = this.props;
    let param = { ...searchItem };
    this.setState({
      searchData: param,
    });
    dispatch({ type: "userSearch", data: "" });
    dispatch(getUsersList(param));
  }

  eyeclick(item) {
    const { history } = this.props;
    history.push(`/Home/Management/Users/MMPL/Edit/${item.userId}`);
  }

  deleteUserList(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch } = this.props;
            let url = `${API.getUserDetail}?userid=${item.userId}`;
            axios
              .get(url)
              .then((response) => {
                let user = {
                  userId: response.data.userId,
                  email: response.data.emailId,
                  isDeleted: true,
                  isAdmin: response.data.isAdmin,
                  mmplShips: "",
                  modifiedBy: currentuser.name,
                };
                dispatch(deleteUserListDetails(user));
                dispatch({
                  type: "getUserDetailsSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch(() => {
                dispatch({
                  type: "getUserDetailsFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {},
        },
      ],
    });
  }

  NewitemNav = () => {
    this.props.history.push("/Home/Management/Users/MMPL/Add");
  };

  renderFilterField(label, name, placeholder, iconClass, type = "text") {
    return (
      <div className="um-filter-field">
        <label className="form-label">{label}</label>
        <div className="um-input-shell">
          <span className="um-input-icon">
            <i className={`fa ${iconClass}`} aria-hidden="true"></i>
          </span>
          <input
            className="form-control"
            type={type}
            name={name}
            placeholder={placeholder}
            value={this.state.searchData[name]}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    );
  }

  render() {
    const { UsersList, t } = this.props;

    return (
      <div className="full-height user-module-master">
        <div className="pt-3">
          <div className="row">
            <div className="col-12">
              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i
                      className="fa fa-filter um-section-title-icon"
                      aria-hidden="true"
                    ></i>
                    {t("MMPLUserManagementContent.SearchFilters")}
                  </h5>
                </div>
                <div className="um-section-body">
                  <div className="um-filter-bar um-filter-bar-single">
                    <div className="um-filter-bar-fields">
                      {this.renderFilterField(
                        t("MMPLUserManagementContent.EmailId"),
                        "Mail",
                        t("MMPLUserManagementContent.EmailId"),
                        "fa-envelope-o",
                        "email"
                      )}
                    </div>
                    <div className="um-filter-bar-actions">
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-btn um-btn-primary"
                        type="button"
                        onClick={() => this.SearchUserList1(1)}
                      >
                        {t("content.Search")}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn um-btn um-btn-secondary"
                        type="button"
                        onClick={this.ClearInput}
                      >
                        {t("content.Clear")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="um-section">
                <div className="um-section-header">
                  <h5 className="um-section-title">
                    <i
                      className="fa fa-users um-section-title-icon"
                      aria-hidden="true"
                    ></i>
                    {t("MMPLUserManagementContent.Users")}
                  </h5>
                  <button
                    type="button"
                    className="um-header-add-btn"
                    onClick={this.NewitemNav}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>
                    <span>{t("ShipManagementContent.Add")}</span>
                  </button>
                </div>
                <div className="um-list-body">
                  {UsersList ? (
                    <UsersCard
                      currentPage={UsersList.pagination.currentPage}
                      arraylist={UsersList.data}
                      pageSize={UsersList.pagination.pageSize || PAGE_SIZE}
                      totalRecords={
                        UsersList.pagination.totalcount
                          ? UsersList.pagination.totalcount
                          : 0
                      }
                      setUpdatedState={(value) => this.SearchUserList(value)}
                      eyeclick={(item) => this.eyeclick(item)}
                      deleteUserList={(item) => this.deleteUserList(item)}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    UsersList: state.UserManagerReducer.UsersList,
    userSearch: state.UserManagerReducer.userSearch,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UserManagement))
);
